const Response = {};

export default Response;

Response.success = function(data) {
  this.$store = Go.Vue.$store;
  this.$store.commit("setCounter", data);
};
